import { render } from "./AlignedTranslationWidget.vue?vue&type=template&id=a66d02ca&scoped=true"
import script from "./AlignedTranslationWidget.vue?vue&type=script&lang=js"
export * from "./AlignedTranslationWidget.vue?vue&type=script&lang=js"

import "./AlignedTranslationWidget.vue?vue&type=style&index=0&id=a66d02ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66d02ca"]])

export default __exports__